// @flow
import type {
  ActionHandlers,
  Reducer,
  Selector,
} from '@travel-frontend/state-handling-sdk';
import type {InsuranceState} from 'redux/uiState/insurance/InsuranceState';

import {
  createReducerUsingActionHandlers,
  PURE,
} from '@travel-frontend/state-handling-sdk';
import {createSelector} from 'reselect';

import {
  REMOVE_NO_OPTION_SELECTED,
  SET_NO_OPTION_SELECTCED,
  SET_TO_CHECKED,
} from 'redux/uiState/insurance/actions';
import {insuranceState} from 'redux/uiState/UiState';

const initState: InsuranceState = {
  noOption: true,
  isChecked: false,
};

const actionCreators: ActionHandlers<InsuranceState> = {
  [PURE(SET_NO_OPTION_SELECTCED)]: (state: InsuranceState) => ({
    ...state,
    noOption: true,
  }),
  [PURE(REMOVE_NO_OPTION_SELECTED)]: (state: InsuranceState) => ({
    ...state,
    noOption: false,
  }),
  [PURE(SET_TO_CHECKED)]: (state: InsuranceState) => ({
    ...state,
    isChecked: true,
  }),
};

export const insuranceReducer: Reducer<InsuranceState> = // $FlowIgnore
  createReducerUsingActionHandlers<InsuranceState>(initState, actionCreators);

export const noOptionSelected: Selector<boolean> = createSelector(
  insuranceState,
  (state: InsuranceState) => state.noOption
);

export const isInsuranceChecked: Selector<boolean> = createSelector(
  insuranceState,
  (state: InsuranceState) => state.isChecked
);
